module.exports = __webpack_public_path__ + "img/ioe-transfer-funds.83a450d9.svg";